export const colorPalettes = {
    sky: {
        light: '#fff',
        dark: '#730f19',
    },
    fund: {
        light: '#02d1d1',
        dark: '#0000FE',
        // light: '#f00',
        // dark: '#0f0',
    },
    fundsky: {
        light: '#ffbb8e',
        dark: '#fe4800',
    },
}